const { numberLabel } = require("simpul");

const topFilterConfigs = [
  {
    key: "top_day",
    interval: "day",
    label: "today",
    color: "#000000",
    title: (dates) => `Top-Rated of ${makeTimeLabel(dates, "Days")}`,
    dates: (dates) =>
      makeDateList(dates, { month: "long", day: "numeric", year: "numeric" }),
  },
  {
    key: "top_week",
    interval: "week",
    label: "this week",
    color: "#2a854a",
    title: (dates) => `Top-Rated of ${makeTimeLabel(dates, "Weeks")}`,
    dates: (dates) =>
      makeDateList(dates, { month: "long", day: "numeric", year: "numeric" }),
  },
  {
    key: "top_month",
    interval: "month",
    label: "this month",
    color: "#a0522d",
    title: (dates) => `Top-Rated of ${makeTimeLabel(dates, "Months")}`,
    dates: (dates) => makeDateList(dates, { month: "long", year: "numeric" }),
  },
  {
    key: "top_year",
    interval: "year",
    label: "this year",
    color: "#708090",
    title: (dates) => `Top-Rated of ${makeTimeLabel(dates, "Years")}`,
    dates: (dates) => makeDateList(dates, { year: "numeric" }),
  },
  {
    key: "top_all_time",
    interval: "",
    label: "all time",
    color: "#daa520",
    title: () => "Top-Rated of All-Time",
    dates: () => [],
  },
].map((config) => ({
  ...config,
  color: { border: config.color, background: config.color + "3b" },
}));

module.exports = topFilterConfigs;

function makeTimeLabel(dates = [], plural) {
  return numberLabel(dates.length, plural).label;
}

function makeDateList(dates = [], options) {
  return dates
    .map((date) => date.toLocaleString("default", options))
    .filter(Boolean);
}

// {
//   interval: "hour",
//   label: "last hour",
// },
// {
//   key: "contest",
//   color: "#800080",
//   title: (dates) => "Contest Winner",
//   dates: (dates) =>
//     makeDateList(dates, { month: "long", day: "numeric", year: "numeric" }),
// },
